/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { skipAutoDateConversion } from '../../../api-dates';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DisbandEnsemble$Params {
  ensembleId: number;
}

export function disbandEnsemble(http: HttpClient, rootUrl: string, params: DisbandEnsemble$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, disbandEnsemble.PATH, 'post');
  if (params) {
    rb.path('ensembleId', params.ensembleId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context: skipAutoDateConversion(context) })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

disbandEnsemble.PATH = '/disband-ensemble-dialog/{ensembleId}';

